import { AppLanguage, AppRoute } from 'const';
import {
  Review,
  AppInit,
  Confirm,
  CheckInPayment,
  ConfirmPayment,
  GeneralError,
  HdfLayout,
  Registration,
  SelectDocumentType,
  TakeDocumentPhoto,
  AddGuest,
} from 'views';
import { appStrings, LocalizedRouter, LocalizedSwitch } from 'modules/i18n';
import { AppLayout } from 'modules/layout';
import 'normalize.css';
import * as qs from 'query-string';
import React, { useEffect, useMemo, useLayoutEffect, useCallback } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentLanguage, setLanguage } from 'store/slice/appConfigSlice';
import FatalErrorBoundary from './views/ErrorBoundary';
import 'typeface-open-sans';
import store from './store/configureStore';

import { SearchPage } from 'views/Search';

export const App = () => {
  const currentLanguage = useSelector(selectCurrentLanguage);
  const qsObject = useMemo(() => qs.parse(window.location.search), []);
  const dispatch = useDispatch();
  const urlBeforeRedirect = window.location.href;

  const initializeLanguage = useCallback(() => {
    const queryLanguage = qsObject.lang;
    if (queryLanguage) {
      dispatch(setLanguage(queryLanguage));
      return;
    }
    const urlStrings = urlBeforeRedirect.split('?');

    for (let i = 0; i < urlStrings.length; i++) {
      const item = urlStrings[i];
      const appLangueValues = Object.values(AppLanguage);

      for (let j = 0; j < appLangueValues.length; j++) {
        const lang = appLangueValues[j];

        if (item.includes(lang)) {
          dispatch(setLanguage(lang));
          return;
        }
      }
    }
  }, []);

  useEffect(() => {
    initializeLanguage();
  }, []);

  return (
    <LocalizedRouter
      RouterComponent={BrowserRouter}
      languages={AppLanguage}
      appStrings={appStrings}
      locale={currentLanguage}
    >
      <AppLayout>
        <FatalErrorBoundary>
          <LocalizedSwitch>
            {!qsObject.token &&
              !window.location.href.startsWith(
                'https://precheckin.royalplaza.com.hk'
              ) && (
                <Route path="*">
                  <GeneralError text="error.message.needReclickUrl" />
                </Route>
              )}
            <Route exact path={AppRoute.AppInit}>
              <AppInit qsObject={qsObject} />
            </Route>
            <Route exact path={AppRoute.Review}>
              <Review />
            </Route>
            <Route exact path={AppRoute.Registration}>
              <Registration />
            </Route>
            <Route exact path={AppRoute.HdfForm}>
              <HdfLayout />
            </Route>
            <Route exact path={AppRoute.Search}>
              <SearchPage />
            </Route>
            <Route exact path={AppRoute.Confirm}>
              <Confirm />
            </Route>
            <Route exact path={AppRoute.SelectDocumentType}>
              <SelectDocumentType />
            </Route>
            <Route exact path={AppRoute.TakeDocumentPhoto}>
              <TakeDocumentPhoto />
            </Route>
            <Route exact path={AppRoute.AddGuest}>
              <AddGuest />
            </Route>
            <Route exact path={AppRoute.Checkinpayment}>
              <CheckInPayment />
            </Route>
            <Route exact path={AppRoute.Confirmpayment}>
              <ConfirmPayment errMsgObj={{}} />
            </Route>
            <Route path="*">
              <GeneralError />
            </Route>
          </LocalizedSwitch>
        </FatalErrorBoundary>
      </AppLayout>
    </LocalizedRouter>
  );
};
